import { i18n } from "@/i18n/i18n-setup";
import Step from '@/interfaces/IStep';
import { ExcludedContractStep } from "./ExcludedContractStep";

export class ContractStep {
    public idContract: string;
    public idStep: number;
    public note: string;
    public currentVersion: [];
    public usernameStep: string;
    public userStep: string;
    public dataStep: Date;

    constructor(
        idContract?: string,
        idStep?: number,
        note?: string,
        currentVersion?: [],
        usernameStep?: string,
        userStep?: string,
        dataStep?: Date
    ) {
        this.idContract = idContract;
        this.idStep = idStep;
        this.note = note;
        this.currentVersion = currentVersion;
        this.usernameStep = usernameStep;
        this.userStep = userStep;
        this.dataStep = dataStep;
    }
}

export enum STEP_ENUM {
    EVALUATION_FORM = 1,
    APPROVAL = 2,
    CONTRACT_UPLOAD = 3,
    SIGNAGE_ORDER = 4,
    INSTALLED_SIGNAGE = 5,
    REFUSED = 6,
    CLOSED = 7
}

const STEP_LIST:Array<Step> = [
    {
        idStep: 1,
        descriptionShort: "1",
        descriptionLong: 'NET20.CONTRACT_STEP_1',
    },
    {
        idStep: 2,
        descriptionShort: "2",
        descriptionLong: 'NET20.CONTRACT_STEP_2',
    },
    {
        idStep: 3,
        descriptionShort: "3",
        descriptionLong: 'NET20.CONTRACT_STEP_3',
    },
    {
        idStep: 4,
        descriptionShort: "4",
        descriptionLong: 'NET20.CONTRACT_STEP_4',
    },
    {
        idStep: 5,
        descriptionShort: "5",
        descriptionLong: 'NET20.CONTRACT_STEP_5',
    }
    // ,{
    //     idStep: 6,
    //     descriptionShort: "6",
    //     descriptionLong: 'NET20.CONTRACT_STEP_6',
    // },
    // {
    //     idStep: 7,
    //     descriptionShort: "7",
    //     descriptionLong: 'NET20.CONTRACT_STEP_7'
    // }
];

let DROP_DOWN_STEP_LIST: Array<any> = [];
let TRANSLATED_STEP_LIST: Array<Step> = [];

export function getDropDownStepList(): Array<any> {
    if(DROP_DOWN_STEP_LIST.length == 0) {
        DROP_DOWN_STEP_LIST.push({ value: null, text: "" });

        STEP_LIST.forEach(function (el) {
            DROP_DOWN_STEP_LIST.push({ value: el.idStep, text: el.idStep + ' - ' + i18n.t(el.descriptionLong) as string});
        });

        let refusedStep: Step = {
            idStep: 6,
            descriptionShort: "6",
            descriptionLong: 'NET20.CONTRACT_STEP_6'
        }
        DROP_DOWN_STEP_LIST.push({ value: refusedStep.idStep, text: refusedStep.idStep + ' - ' + i18n.t(refusedStep.descriptionLong) as string});

        let closingStep: Step = {
            idStep: 7,
            descriptionShort: "7",
            descriptionLong: 'NET20.CONTRACT_STEP_7'
        }
        DROP_DOWN_STEP_LIST.push({ value: closingStep.idStep, text: closingStep.idStep + ' - ' + i18n.t(closingStep.descriptionLong) as string});

    }
    return DROP_DOWN_STEP_LIST;
}

export function getStepsDescription(lastStep: number, excludedSteps: Array<ExcludedContractStep> = null): Array<Step> {
    TRANSLATED_STEP_LIST = new Array<Step>();
    if(excludedSteps != null && excludedSteps.length > 0) {    
        STEP_LIST.forEach(function (el) {
            if(excludedSteps.findIndex( x=> x.idStep == el.idStep) < 0) {
                let step: Step = {
                    idStep: el.idStep,
                    descriptionShort: el.descriptionShort,
                    descriptionLong: i18n.t(el.descriptionLong) as string
                }
                TRANSLATED_STEP_LIST.push(step);
            }
        });
    } else {
        STEP_LIST.forEach(function (el) {
            let step: Step = {
                idStep: el.idStep,
                descriptionShort: el.descriptionShort,
                descriptionLong: i18n.t(el.descriptionLong) as string
            }
            TRANSLATED_STEP_LIST.push(step);
        });
    }
    if(lastStep == STEP_ENUM.REFUSED) {
        let refusedStep: Step = {
            idStep: 6,
            descriptionShort: "6",
            descriptionLong: i18n.t('NET20.CONTRACT_STEP_6') as string
        }
        TRANSLATED_STEP_LIST.push(refusedStep);
    } else {
        let closingStep: Step = {
            idStep: 7,
            descriptionShort: "7",
            descriptionLong: i18n.t('NET20.CONTRACT_STEP_7') as string
        }
        TRANSLATED_STEP_LIST.push(closingStep);
    }
    return TRANSLATED_STEP_LIST;
}